import { Route } from "react-router-dom";
import AllPodcasts from "@pages/media-academy/all-podcast";
import Slides from "@pages/media-academy/slides";
import CreateSlide from "@pages/media-academy/create-slide";
import SingleSlide from "@pages/media-academy/single-slide";

export const mediaRoutes = [
  <Route key="podcast" path="/podcast" element={<AllPodcasts />} />,
  <Route key="podcast-new" path="/podcast/new" element={<AllPodcasts />} />,
  <Route key="slides" path="/slides" element={<Slides />} />,
  <Route key="slides-create" path="/slides/create" element={<CreateSlide />} />,
  <Route key="single-slide" path="/slides/:id" element={<SingleSlide />} />,
];
